export function formatBips(value: number | undefined | null) {
  if (value === undefined || value === null || !Number.isSafeInteger(value)) {
    return 'n/a'
  }
  return `${(value / 100).toFixed(2)}%`
}
